// extracted by mini-css-extract-plugin
module.exports = {"tag":"EventTag_tag__9iUfZ"};